import { type DeliveryChunk, OrderServicesWithAllPaymentMethods } from '@/shared/api/order';
import type { ArrayIntervalFieldValue } from '@/shared/components/IntervalInput';

export const checkCourierAllPaymentMethods = (
    courierIntervals: ArrayIntervalFieldValue,
    deliveryChunks: Array<DeliveryChunk>
) =>
    courierIntervals.every((interval) => {
        const chunkData = deliveryChunks.find((chunk) => chunk.id === interval.chunkId);

        if (!chunkData?.is_available) {
            return true;
        }

        if (interval.intervalField.type === 'notInterval') {
            return false;
        }

        return OrderServicesWithAllPaymentMethods.includes(interval.intervalField.serviceType);
    });
